import { Box, Button, ButtonGroup, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BlockIcon from "@mui/icons-material/Block";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import CheckIcon from "@mui/icons-material/Check";

const ICONS = {
  delete: <DeleteForeverIcon fontSize="small" />,
  edit: <EditIcon fontSize="small" />,
  view: <VisibilityIcon fontSize="small" />,
  discount: <LocalOfferIcon fontSize="small" />,
  block: <BlockIcon fontSize="small" />,
  unblock: <LockOpenIcon fontSize="small" />,
  remove: <PersonRemoveIcon fontSize="small" />,
  activate: <CheckIcon fontSize="small" />,
};

const TYPE_COLORS = {
  delete: "#E9313C",
  edit: "#ffac47",
  block: "#c084fc",
  unblock: "#49BE25",
  remove: "#38bdf8",
  view: "#94a3b8",
  discount: "#2dd4bf",
  activate: "#60a5fa",
};

const actionSx = (type) => {
  const color = TYPE_COLORS[type];
  if (!color) return undefined;
  return {
    color,
    borderColor: color,
    "&:hover": {
      borderColor: color,
      backgroundColor: `${color}22`,
    },
  };
};

const TableActions = ({ actions = [], compact = false }) => {
  const isNarrow = useMediaQuery("(max-width:960px)");
  const isCompact = compact || isNarrow;
  const visible = actions.filter(Boolean);

  if (visible.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
      }}
    >
      {isCompact ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
          {visible.map((action) => (
            <Tooltip key={action.key || action.label} title={action.label}>
              <IconButton
                size="small"
                color={action.color}
                onClick={action.onClick}
                sx={actionSx(action.type)}
              >
                {action.icon || ICONS[action.type]}
              </IconButton>
            </Tooltip>
          ))}
        </Box>
      ) : (
        <ButtonGroup variant="outlined" size="small">
          {visible.map((action) => (
            <Tooltip key={action.key || action.label} title={action.label}>
              <Button
                color={action.color}
                onClick={action.onClick}
                startIcon={action.icon || ICONS[action.type]}
                sx={actionSx(action.type)}
              >
                {action.label}
              </Button>
            </Tooltip>
          ))}
        </ButtonGroup>
      )}
    </Box>
  );
};

export default TableActions;
